import { render, staticRenderFns } from "./ImportLeadPage.vue?vue&type=template&id=2dccf958&"
import script from "./ImportLeadPage.vue?vue&type=script&lang=js&"
export * from "./ImportLeadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports